import { CommandContext } from '@farris/devkit';

export abstract class Service {
  public context: CommandContext;
  /**
   * å½ä»¤åæ°
   */
  public get eventParam() {
    return this.context && this.context.eventParam || null;
  }
}
